/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewCourier
 */
export interface NewCourier {
    /**
     * 
     * @type {string}
     * @memberof NewCourier
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCourier
     */
    shortName?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCourier
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCourier
     */
    hostingUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCourier
     */
    slogan?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCourier
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NewCourier
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof NewCourier
     */
    expiryDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof NewCourier
     */
    mailboxPaddingLength?: number;
    /**
     * 
     * @type {string}
     * @memberof NewCourier
     */
    realm: string;
    /**
     * 
     * @type {string}
     * @memberof NewCourier
     */
    webUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCourier
     */
    imageBucket?: string;
    /**
     * 
     * @type {number}
     * @memberof NewCourier
     */
    planId?: number;
}

/**
 * Check if a given object implements the NewCourier interface.
 */
export function instanceOfNewCourier(value: object): value is NewCourier {
    if (!('realm' in value) || value['realm'] === undefined) return false;
    return true;
}

export function NewCourierFromJSON(json: any): NewCourier {
    return NewCourierFromJSONTyped(json, false);
}

export function NewCourierFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewCourier {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'hostingUrl': json['hostingUrl'] == null ? undefined : json['hostingUrl'],
        'slogan': json['slogan'] == null ? undefined : json['slogan'],
        'email': json['email'] == null ? undefined : json['email'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'expiryDate': json['expiryDate'] == null ? undefined : (new Date(json['expiryDate'])),
        'mailboxPaddingLength': json['mailboxPaddingLength'] == null ? undefined : json['mailboxPaddingLength'],
        'realm': json['realm'],
        'webUrl': json['webUrl'] == null ? undefined : json['webUrl'],
        'imageBucket': json['imageBucket'] == null ? undefined : json['imageBucket'],
        'planId': json['planId'] == null ? undefined : json['planId'],
    };
}

export function NewCourierToJSON(json: any): NewCourier {
    return NewCourierToJSONTyped(json, false);
}

export function NewCourierToJSONTyped(value?: NewCourier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'shortName': value['shortName'],
        'imageUrl': value['imageUrl'],
        'hostingUrl': value['hostingUrl'],
        'slogan': value['slogan'],
        'email': value['email'],
        'isActive': value['isActive'],
        'expiryDate': value['expiryDate'] == null ? undefined : ((value['expiryDate']).toISOString()),
        'mailboxPaddingLength': value['mailboxPaddingLength'],
        'realm': value['realm'],
        'webUrl': value['webUrl'],
        'imageBucket': value['imageBucket'],
        'planId': value['planId'],
    };
}

